class FaqElement extends HTMLElement {
    constructor() {
        super();
        this.initialise()
    }
    declareVariables() {
        this.KEY_ENTER = 13;
        this.headerHeight = 62;
        this.isMatchesMouseDown = false;
        this.faqs = [];
        this.currentPage = {};
        this.currentCategory = {};
        this.pages = [{
            id: "main",
            title: "Feel free to ask us<br>a question.",
            sections: ["pageButtons"],
            categories: []
        }, {
            id: "general",
            title: "General.",
            sections: ["faqAccordeon", "icon-general", "back-button-section"],
            categories: [{
                id: "general",
                title: ""
            }]
        }, {
            id: "products",
            title: "Products.",
            sections: ["productButtons", "faqAccordeon", "icon-titan", "back-button-section"],
            categories: [{
                id: "keon",
                title: "KEON"
            }, {
                id: "onyx",
                title: "Onyx+ And Realm"
            }, {
                id: "pulse",
                title: "Pulse Interactive"
            }, {
                id: "titan",
                title: "Titan"
            }, {
                id: "pearl2",
                title: "Pearl2"
            }, {
                id: "esca2",
                title: "Esca2"
            }, {
                id: "lumen",
                title: "Lumen"
            }, {
                id: "cliona",
                title: "Cliona"
            }, {
                id: "accessories",
                title: "Accessories"
            }]
        }, {
            id: "connection",
            title: "Connection.",
            sections: ["faqAccordeon", "icon-connection", "back-button-section"],
            categories: [{
                id: "connection",
                title: ""
            }]
        }, {
            id: "shipping",
            title: "Shipping & Returns.",
            sections: ["faqAccordeon", "icon-shipping", "back-button-section"],
            categories: [{
                id: "shipping",
                title: ""
            }]
        }];
        this.searchInput = this.querySelector("search-input");
        this.dynamicSections = this.querySelectorAll(".dynamic-section");
        this.titleElement = this.querySelector("#faqTitle");
        this.subtitleElement = this.querySelector("#subTitle");
        this.collapsibles = this.querySelectorAll("div.collapsible");
        for (let i = 0; i < this.collapsibles.length; i++) {
            const collapsible = this.collapsibles[i];
            collapsible["element"] = collapsible.querySelector("collapsible-element")
        }
    }
    initialise() {
        this.declareVariables();
        this.collapsibles.forEach((block => {
            const id = block.getAttribute("id");
            const category = block.getAttribute("data-category");
            const question = block.querySelector(".collapsible__title").innerHTML;
            const answer = block.querySelector(".collapsible__content").innerHTML;
            const search = `${question} ${answer}`.toLowerCase();
            this.faqs.push({
                id,
                category,
                search,
                question,
                answer
            })
        }));
        const pageParam = new URL(window.location.href).searchParams.get("page");
        if (pageParam) {
            if(window.templateName.includes('product.powershot') == false) {
                this.setPage(this.findPage(pageParam))
            }
        } else {
          if(window.templateName.includes('product.powershot') == false) {
            this.setPage(this.findPage("main"));
            window.history.replaceState({
                page: "main"
            }, "", "?page=main")
          }      
        }
        this.subscribe()
    }
    search(terms) {
        let resultArray = [];
        for (let i = 0; i < this.faqs.length; i++) {
            let faq = this.faqs[i];
            for (let j = 0; j < terms.length; j++) {
                let term = terms[j].toLowerCase();
                if (term === "") {
                    continue
                }
                if (faq.search.indexOf(term) !== -1) {
                    if (!resultArray.some((s => s === faq.question))) {
                        resultArray.push(faq.question)
                    } else {
                        break
                    }
                }
            }
        }
        this.searchInput.showResults(resultArray, (question => {
            this.focusOnQuestion(question)
        }))
    }
    setCategory(categoryId) {
        const newCategory = this.findCategoryInPage(this.currentPage, categoryId);
        this?.querySelector(`button[data-category=${this.currentCategory.id}]`)?.classList.remove("faq-selected");
        this?.querySelector(`button[data-category=${newCategory.id}]`)?.classList.add("faq-selected");
        for (const category of this.currentPage.categories) {
            const element = this.querySelector(`button[data-category=${category.id}]`);
            if (newCategory.id === category.id) {
                element.classList.remove("faq-unselected")
            } else {
                element.classList.add("faq-unselected")
            }
        }
        if (newCategory.title) {
            this.subtitleElement.innerHTML = newCategory.title;
            this.subtitleElement.parentNode.style.display = ""
        }
        this.collapsibles.forEach((block => {
            if (block.getAttribute("data-category") === newCategory.id) {
                block.classList.remove("hidden")
            } else {
                block.classList.add("hidden")
            }
        }));
        this.currentCategory = newCategory;
        const page = this.pages.find((s => s.id === "products"));
        if (page?.categories?.includes(this.currentCategory)) {
            this.subtitleElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            })
        }
    }
    setPage(page) {
        if (this.titleElement != null) {
            this.titleElement.innerHTML = page.title;
        }
        this.dynamicSections.forEach((section => {
            const id = section.getAttribute("id");
            if (page.sections.includes(id)) {
                section.classList.remove("hidden")
            } else {
                section.classList.add("hidden")
            }
        }));
        this.collapsibles.forEach((block => {
            block.classList.add("hidden");
            block.element.close(block.element)
        }));
        if (this.subtitleElement != null) {
            this.subtitleElement.innerHTML = "";
            this.subtitleElement.parentNode.style.display = "none";
        }
        this.currentPage = page;
        if (page.categories.length === 1) {
            this.collapsibles.forEach((block => {
                if (block.getAttribute("data-category") === page.categories[0].id) {
                    block.classList.remove("hidden")
                } else {
                    block.classList.add("hidden")
                }
            }))
        }
        if(window.templateName != 'page.powershot' || window.templateName != 'product.powershot') {
          window.history.pushState({
              page: page.id
          }, "", "?page=" + page.id);
          window.scrollTo(0, 0)
        }
    }
    focusOnQuestion(question) {
        const faq = this.faqs.find((s => s.question === question));
        const faqElement = document.getElementById(faq.id);
        const page = this.findPageByCategoryId(faq.category);
        this.setPage(page);
        if (page.id === "products") {
            this.setCategory(faq.category)
        }
        window.scrollTo({
            top: faqElement.offsetTop - this.getHeaderHeight(),
            behavior: "smooth"
        });
        faqElement.element.open(faqElement.element)
    }
    findCategoryInPage(page, categoryId) {
        for (let i = 0; i < page.categories.length; i++) {
            if (page.categories[i].id === categoryId) {
                return page.categories[i]
            }
        }
        return null
    }
    findPageByCategoryId(categoryId) {
        for (let i = 0; i < this.pages.length; i++) {
            for (let j = 0; j < this.pages[i].categories.length; j++) {
                if (this.pages[i].categories[j].id === categoryId) {
                    return this.pages[i]
                }
            }
        }
    }
    findPage(pageId) {
        return this.pages.find((s => s.id === pageId))
    }
    clearSearchInput() {
        this.searchInput.clear()
    }
    getHeaderHeight() {
        const root = document.querySelector(":root");
        const rootStyles = getComputedStyle(root);
        if (screen.width > 1200) {
            return rootStyles.getPropertyValue("--header-height-lg").split("p")[0]
        } else {
            return rootStyles.getPropertyValue("--header-height").split("p")[0]
        }
    }
    subscribe() {
        window.addEventListener("popstate", (backEvent => {
            const page = this.findPage(backEvent.state?.page);
            if (page && this.currentPage !== page) {
                this.setPage(page)
            }
            this.clearSearchInput()
        }));
        const backBtns = this.querySelectorAll(".back-button");
        backBtns.forEach((btn => {
            btn.addEventListener("click", (() => {
                this.setPage(this.findPage("main"));
                this.clearSearchInput()
            }))
        }));
        if(this.searchInput) {
            this.searchInput.addInteractionEventListener((terms => this.search(terms)));
        }
        const pageButtons = this.querySelectorAll(".page-button");
        pageButtons.forEach((pageButton => {
            pageButton.addEventListener("click", (e => {
                e.stopPropagation();
                e.stopImmediatePropagation();
                const pageId = pageButton.getAttribute("data-page");
                const page = this.findPage(pageId);
                this.setPage(page)
            }))
        }));
        const btns = this.querySelectorAll(".product-button");
        btns.forEach((btn => {
            btn.addEventListener("click", (e => {
                e.stopPropagation();
                e.stopImmediatePropagation();
                const categoryId = btn.getAttribute("data-category");
                this.setCategory(categoryId)
            }))
        }))
    }
}
if (!customElements.get("faq-element")) {
    customElements.define("faq-element", FaqElement)
}
Promise.allSettled([customElements.whenDefined("faq-element")]).then((() => {
    setTimeout((() => {
        const cont = document.querySelector(".container");
        cont.style.opacity = "";
        cont.classList.add("ready")
    }), 100)
}));
//# sourceMappingURL=faq.js.map